import { AppBar, Toolbar, useTheme } from '@mui/material';
import { memo } from 'react';

import { useUserContext } from 'src/auth/useUserContext';
import { NavSectionHorizontal } from 'src/components/nav-section';
import { HEADER } from 'src/config-global';
import { useOrganizationContext } from 'src/sections/@dashboard/organization/hooks/useOrganizationContext';
import { useCurrentVisitContext } from 'src/sections/@dashboard/visit/hooks/useCurrentVisitContext';
import {
  canWriteStock,
  isWarehouseVisible,
  useWarehouseActivation,
} from 'src/sections/@dashboard/warehouse/hooks/useWarehouseActivation';
import { Roles } from 'src/types/User';
import { DARK_BACKGROUND } from 'src/theme/palette';
import getNavConfig from './config-navigation';
import getUserNavConfig from './user-config-navigation';
// ----------------------------------------------------------------------

function NavHorizontal(): JSX.Element {
  const theme = useTheme();
  const { pendingVisits } = useCurrentVisitContext();
  const {
    isUserRole,
    isAdminRole,
    isOrganizationAdminRole,
    isOrganizationOwnerRole,
    isProfessionalRole,
    data: userData,
  } = useUserContext();
  const { isOrganizationAdminWithoutOrganizations, selectedRole } =
    useOrganizationContext();
  const isLive =
    isProfessionalRole &&
    selectedRole === Roles.professional &&
    pendingVisits.length > 0;
  const { data: warehouseActivation } = useWarehouseActivation();
  return (
    <AppBar
      component="nav"
      color="transparent"
      sx={{
        boxShadow: theme.customShadows.z8,
        top: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
      }}
    >
      {!isOrganizationAdminWithoutOrganizations && userData?.onboarded && (
        <Toolbar
          sx={{
            backgroundColor: DARK_BACKGROUND.default,
          }}
        >
          <NavSectionHorizontal
            data={
              isUserRole
                ? getUserNavConfig()
                : getNavConfig({
                    isLive,
                    showWarehouse: isWarehouseVisible(warehouseActivation),
                    warehouseEnabled: canWriteStock(warehouseActivation),
                    access: {
                      isAdmin: isAdminRole,
                      isOrganizationAdmin: isOrganizationAdminRole,
                      isOrganizationOwner: isOrganizationOwnerRole,
                      isProfessional: isProfessionalRole,
                      selectedRole,
                    },
                  })
            }
          />
        </Toolbar>
      )}
    </AppBar>
  );
}

export default memo(NavHorizontal);
